import * as React from 'react';

/**
 * An SVG containing a gray circle icon
 */
const GrayCircle = ({ title }: { title: string }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>{title}</title>
    <rect width="20" height="20" rx="10" fill="#E8EEF7" />
  </svg>
);

export default GrayCircle;
